import {jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class Rol {
    @jsonMember
    name: string;
}
